var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeedtest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1866_2540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9914 15.504L23.9915 15.5031C23.9915 15.5011 23.9912 15.4991 23.9912 15.4969C23.7785 10.2247 19.3788 6.00008 14 6C13.9992 6 13.9984 6 13.9977 6L13.997 6.00008C8.48441 6.00162 4 10.4405 4 15.8964C4 17.9561 4.64047 19.9359 5.85211 21.6218C6.14313 22.0266 6.7107 22.1214 7.11988 21.8335C7.52902 21.5455 7.6248 20.9838 7.33375 20.5788C6.44211 19.3382 5.92988 17.9036 5.83543 16.4028H7.63926C8.14133 16.4028 8.54836 16 8.54836 15.5031C8.54836 15.0062 8.14133 14.6034 7.63926 14.6034H5.92293C6.16773 13.1003 6.83184 11.7344 7.79262 10.6274L8.86074 11.6843C9.03824 11.8599 9.27086 11.9478 9.50352 11.9478C9.73617 11.9478 9.96891 11.8599 10.1464 11.6842C10.5013 11.3329 10.5013 10.7632 10.1463 10.4119L9.12277 9.39911C10.2568 8.56315 11.6163 8.01117 13.093 7.84924L13.0962 9.20525C13.0974 9.70137 13.5041 10.1028 14.0052 10.1028C14.006 10.1028 14.0067 10.1028 14.0074 10.1028C14.5095 10.1016 14.9155 9.69789 14.9144 9.20103L14.9112 7.84974C16.3887 8.01256 17.7488 8.56586 18.8829 9.40325L17.8633 10.4122C17.5082 10.7635 17.5082 11.3331 17.8632 11.6845C18.0407 11.8602 18.2734 11.9481 18.506 11.9481C18.7386 11.9481 18.9713 11.8603 19.1488 11.6846L20.2118 10.6327C21.1702 11.7388 21.8326 13.1028 22.077 14.6034H20.3706C19.8685 14.6034 19.4615 15.0062 19.4615 15.5031C19.4615 15.9999 19.8685 16.4027 20.3706 16.4027H22.1645C22.0701 17.9041 21.5578 19.3386 20.666 20.5786C20.3749 20.9834 20.4704 21.5451 20.8795 21.8332C21.0394 21.9459 21.2235 21.9999 21.4059 21.9999C21.6901 21.9999 21.97 21.8685 22.1473 21.6219C23.3594 19.9368 24 17.9569 24 15.8964C24 15.7649 23.9966 15.6342 23.9914 15.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8566 13.1046C16.4634 12.7957 15.8915 12.8607 15.5793 13.2498L14.113 15.0775C14.0993 15.0772 14.0857 15.0765 14.0718 15.0765C13.2364 15.0765 12.5566 15.7491 12.5564 16.5762C12.5566 17.4029 13.2364 18.0754 14.0718 18.0754C14.4765 18.0754 14.857 17.9194 15.1431 17.6363C15.4293 17.3531 15.5869 16.9765 15.5868 16.5761C15.5869 16.446 15.5699 16.3184 15.5376 16.1956L17.0033 14.3686C17.3155 13.9795 17.2498 13.4135 16.8566 13.1046Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1866_2540",
    x: -4,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1866_2540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1866_2540",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedtest);
export default __webpack_public_path__ + "static/media/speedtest.41dd4aaade55dcb519083577960f1476.svg";
export { ForwardRef as ReactComponent };